import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import { Randomcode } from '../../components/rendom_code';
import { Helmet } from "react-helmet";
import Lodinging from "../../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Statusbarpopup from '../../master_root/statusbarpopup';

import { Createtask } from './create_task';

import { VscAdd, VscClose } from 'react-icons/vsc';
import { Createitem } from '../item_root/create_item';
import { Createtaskgroup } from '../create_group_item';

export default function Addtask({ data, onClose }) {
  const puid = data?.puid;
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [taskname, setTaskname] = useState('');
  const [description, setdescription] = useState('');
  const [taskdata, setTaskdata] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#3B82F6");
  const [groupname, setGroupname] = useState('');
  const [duedate, setDuedate] = useState(Timestamp.now().toDate());
  const capitalizeFirst = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Save new project
  const create_task = async () => {
    if (!groupname.trim()) {
      showToast("Please enter groupname");
      setLoading(false);
      return;
    }
    if (!taskname.trim()) {
      showToast("Please enter taskname");
      setLoading(false);
      return;
    }
    if (!description.trim()) {
      showToast("Please enter description.");
      setLoading(false);
      return;
    }

    if (!puid) {
      showToast("User identifier missing.");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const taskuid = Randomcode(18);
      const result = await Createtask({
        puid,
        taskuid,
        taskname: capitalizeFirst(taskname),
        color: selectedColor,
        description: capitalizeFirst(description),
      });

      if (!result.success) {
        //showToast("Failed to create task: " + (result.error || "Unknown error"));
        return;
      }

      const groupuid = Randomcode(19);
      const resultgroup = await Createtaskgroup({
        groupname: capitalizeFirst(groupname),
        puid,
        groupuid,
        taskuid,
        color: selectedColor,
        description: capitalizeFirst(description),
      });

      if (!resultgroup.success) {
        //showToast("Failed to create task group: " + (resultgroup.error || "Unknown error"));

        return;
      }

      const itemuid = Randomcode(20);
      const resultitem = await Createitem({
        groupname: capitalizeFirst(groupname),
        groupuid,
        puid,
        itemuid,
        due_date_time: Timestamp.fromDate(duedate),
        taskuid,
        itemname: "Item name",
        color: selectedColor,
        description: capitalizeFirst(description),
      });

      if (resultitem.success) {
        showToast("Task created successfully.");
        onClose();
      } else {
        showToast("Task created, but item failed: " + (resultitem.error || "Unknown error"));
      }

      onClose();
    } catch (ex) {
      console.error("An error occurred:", ex);
      showToast("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };



  const fetchtaskData = async () => {
    setIsLoading(true);
    try {
      const smsQuery = query(collection(db, "projects"),
        where("adminguid", "==", Cookies.get("adminguid"))

      );
      const smsSnapshot = await getDocs(smsQuery);
      const dataList = smsSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));
      setTaskdata(dataList);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  };
  //color


  const handleColorClick = (color) => {
    setSelectedColor(color);
    console.log("Selected Color:", color); // or pass it to parent component
  };
  const colorList = [
    '#3B82F6', // Blue (Primary)
    '#10B981', // Emerald (Success)
    '#F59E0B', // Amber (Warning)
    '#EF4444', // Red (Error)
    '#6366F1', // Indigo
    '#8B5CF6', // Violet
    '#EC4899', // Pink
    '#F43F5E', // Rose
    '#0EA5E9', // Sky Blue
    '#14B8A6', // Teal
    '#22C55E', // Green
    '#EAB308', // Yellow
    '#F97316', // Orange
    '#1F2937', // Dark Slate (Text/Base)
    '#A3A3A3', // Cool Gray
    '#6B7280', // Gray
    '#94A3B8', // Slate Gray
    '#D4D4D8', // Light Gray 
  ];
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <Statusbarpopup data={'Add New Task'} />
        <div className="container_roots">
          <Helmet>
            <title>Browse Job Tasks | EditorTask - Find & Hire Creative Talent</title>

            <meta name="description" content="Discover the latest freelance job tasks listed on EditorTask. From video editing to digital marketing, connect with top talent across India." />
            <meta name="keywords" content="job listings, freelance tasks, hire editors, creative work, India job portal, remote jobs, task board, EditorTask jobs" />
            <meta name="author" content="editortask.com" />
            <meta name="robots" content="index, follow" />

            <meta property="og:title" content="Browse Job Tasks | EditorTask - Find & Hire Creative Talent" />
            <meta property="og:description" content="Explore freelance and project-based job tasks posted on EditorTask. Connect with skilled editors, designers, marketers, and more." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.editortask.com/jobs" />
            <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
          </Helmet>

          <div className="container_size">
            <br />
            <div className='post-container'  >
              <div className='post_div'>
                <table style={{ borderTop: `solid 4px ${selectedColor}` }}>
                  <tbody>
                    <tr>

                      <td>
                        <input
                          placeholder='Group Name'
                          maxLength={50}
                          className='projects-input-box'
                          value={groupname}
                          onChange={(e) => setGroupname(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>

                      <td>
                        <input
                          placeholder='Name'
                          maxLength={50}
                          className='projects-input-box'
                          value={taskname}
                          onChange={(e) => setTaskname(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea
                          className='projects-input-box'
                          maxLength={1000}
                          rows={5}
                          placeholder='Description'
                          value={description}
                          onChange={(e) => setdescription(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                          {colorList.map((color, index) => (
                            <div
                              key={index}
                              onClick={() => handleColorClick(color)}
                              style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '100%',
                                backgroundColor: color,
                                cursor: 'pointer',
                                border: selectedColor === color ? '1px solid #333' : '1px solid ' + color,
                                margin: '2px'
                              }}
                            />
                          ))}
                        </div>

                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className='item-master-grid'></div>

                      </td>
                    </tr>
                    <tr>
                      <td>
                        <br />
                        <div className='button-ui' onClick={create_task}>
                          <VscAdd className='icon' /> {loading ? "Creating..." : "Create"}
                        </div>

                        <div className='button-ui3' style={{ marginLeft: `20px` }} onClick={onClose}>
                          <VscClose className='icon' /> {loading ? "Creating..." : "Close"}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
